export const environment = {
  production: false,
  baseUrl: 'https://api.dev.chiefnet.io',
  gaTrackingId: 'G-HJVQ1GFJEM',
  grafanaBaseUrl: 'https://dashboard.dev.chiefnet.io',
};
